import React, { Component, Fragment } from 'react';
import { Main, Filter } from 'Containers/';
import { Button, Form, Checkbox, Grid, Input, Icon } from 'semantic-ui-react';
import _ from 'lodash';

import { withRecipesSubscription } from 'Common/Components/RecipeSearch';
import { RecipeTable } from 'Common/Components/RecipeTable/RecipeTable';
import { TitledCard } from 'Components/';

import 'PageStyles/managerecipe/index.less';

class ManageRecipe extends Component {
  state = {
    searchText: '',
    categoryOption: null,
    sourceOption: null,
    groupOption: null,
    mealComponentOption: null,
    searchItemsOnMenus: false,
    disableHoverOver: false,
    showInactive: false,
  };
  getMainProps = () => {
    const { isReadOnly } = this.props;

    return {
      toolbox: {
        shown: false,
        isReadOnly: isReadOnly,
      },
      shouldNotUsePageWidth: true,
    };
  };

  componentDidMount() {
    this.searchRecipes();
  }

  componentWillUnmount() {
    this.props.resetRecipeSearch();
  }

  searchRecipes = async () => {
    const { searchRecipes } = this.props;
    const {
      searchText,
      categoryOption,
      sourceOption,
      groupOption,
      mealComponentOption,
      searchItemsOnMenus,
      showInactive,
    } = this.state;

    const searchParams = _.pickBy(
      {
        newSearch: true,
        Search: searchText,
        RecipeCategoryId: categoryOption,
        SourceId: sourceOption,
        GroupId: groupOption,
        Component: mealComponentOption,
        SearchItemsOnMenus: searchItemsOnMenus,
        UsePaging: false,
        ShowInactive: showInactive,
      },
      value => !_.isNil(value)
    );
    await searchRecipes(searchParams);
  };
  debouncedSearchRecipes = _.debounce(this.searchRecipes, 250);

  onSearchTextChange = e => {
    const {
      target: { value },
    } = e;

    this.setState({ searchText: value, page: 0 }, this.debouncedSearchRecipes);
  };

  setToggle = field => (e, data) => {
    this.setState({ [field]: data.checked }, this.debouncedSearchRecipes);
  };

  handleAddRecipe = () => {
    const { history } = this.props;
    history.push('/managerecipe/edit');
  };

  get recipeTableProps() {
    const { searchResults, loadingRecipes, ...rest } = this.props;

    return {
      ...rest,
      data: searchResults,
      loading: loadingRecipes,
    };
  }

  render() {
    const { searchText, isReadOnly } = this.props;
    const { searchItemsOnMenu, showInactive } = this.state;

    return (
      <Fragment>
        <Filter title="Manage Recipes">
          <Grid textAlign="right">
            <Grid.Row textAlign="right">
              <Grid.Column width={4} floated="right" className="menus-filter">
                <Checkbox
                  label="Search Cycle Menu"
                  toggle
                  onChange={this.setToggle('searchItemsOnMenus')}
                  checked={searchItemsOnMenu}
                />
              </Grid.Column>
              <Grid.Column width={4} floated="right" className="menus-filter">
                <Checkbox
                  label="Show Inactive Only"
                  toggle
                  onChange={this.setToggle('showInactive')}
                  checked={showInactive}
                />
              </Grid.Column>
              {!isReadOnly && (
                <Grid.Column width={6} floated="right">
                  <Button fluid onClick={this.handleAddRecipe}>
                    Add Recipe
                  </Button>
                </Grid.Column>
              )}
            </Grid.Row>
          </Grid>
        </Filter>
        <Main {...this.getMainProps()}>
          <Grid>
            <Grid.Row verticalAlign="middle">
              <Grid.Column width={8}>
                <Form.Field inline>
                  <Input
                    placeholder="Smartest Lunchroom Search"
                    fluid
                    icon={<Icon name="search" />}
                    iconPosition="left"
                    onChange={this.onSearchTextChange}
                    value={searchText}
                  />
                </Form.Field>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <TitledCard title="Recipes">
            <RecipeTable {...this.recipeTableProps} />
          </TitledCard>
        </Main>
      </Fragment>
    );
  }
}

ManageRecipe = withRecipesSubscription(ManageRecipe);

export { ManageRecipe };



// WEBPACK FOOTER //
// ./src/pages/managerecipe/ManageRecipe.js